import { useEffect, useRef } from 'react';

const WORDS = ['software', 'products', 'platforms'];

/* Kinetic hero word — cycles through WORDS, animating the swap and
   easing the container width between them. Respects reduced-motion. */
const RotatingWord = () => {
  const rotRef = useRef<HTMLSpanElement>(null);
  const wordRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const rot = rotRef.current;
    const wordEl = wordRef.current;
    if (!rot || !wordEl || reduce) return;

    const meas = document.createElement('span');
    const cs = getComputedStyle(wordEl);
    meas.style.cssText =
      'position:absolute;left:-9999px;top:-9999px;white-space:nowrap;visibility:hidden;';
    meas.style.fontSize = cs.fontSize;
    meas.style.fontFamily = cs.fontFamily;
    meas.style.fontWeight = cs.fontWeight;
    meas.style.fontStyle = cs.fontStyle;
    meas.style.letterSpacing = cs.letterSpacing;
    document.body.appendChild(meas);

    const setWidth = (w: string) => {
      meas.textContent = w;
      rot.style.width = Math.ceil(meas.getBoundingClientRect().width) + 'px';
    };

    let i = 0;
    let swapTimer = 0;
    const ready = document.fonts ? document.fonts.ready : Promise.resolve();
    ready.then(() => setWidth(WORDS[0]));

    const onResize = () => setWidth(WORDS[i]);
    window.addEventListener('resize', onResize);

    const interval = setInterval(() => {
      wordEl.style.transition = 'transform .4s cubic-bezier(.55,0,.2,1), opacity .4s';
      wordEl.style.transform = 'translateY(-0.42em)';
      wordEl.style.opacity = '0';
      swapTimer = window.setTimeout(() => {
        i = (i + 1) % WORDS.length;
        wordEl.textContent = WORDS[i];
        setWidth(WORDS[i]);
        wordEl.style.transition = 'none';
        wordEl.style.transform = 'translateY(0.42em)';
        wordEl.style.opacity = '0';
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            wordEl.style.transition = 'transform .46s cubic-bezier(.2,.7,.2,1), opacity .46s';
            wordEl.style.transform = 'translateY(0)';
            wordEl.style.opacity = '1';
          })
        );
      }, 400);
    }, 2900);

    return () => {
      clearInterval(interval);
      clearTimeout(swapTimer);
      window.removeEventListener('resize', onResize);
      meas.remove();
    };
  }, []);

  return (
    <span
      ref={rotRef}
      className="relative inline-block align-baseline"
      style={{ transition: 'width .5s cubic-bezier(.2,.7,.2,1)' }}>
      <span ref={wordRef} className="inline-block" style={{ willChange: 'transform, opacity' }}>
        {WORDS[0]}
      </span>
    </span>
  );
};

export default RotatingWord;
